import { render, staticRenderFns } from "./AreaManage.vue?vue&type=template&id=3c7cf255&"
import script from "./AreaManage.vue?vue&type=script&lang=js&"
export * from "./AreaManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports